// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface BillingAccountID
 */
export interface BillingAccountID {
  /**
   * Billing account identifier
   * @type {string}
   * @memberof BillingAccountID
   */
  id: string;
}

/**
 * Check if a given object implements the BillingAccountID interface.
 */
export function instanceOfBillingAccountID(
  value: object,
): value is BillingAccountID {
  if (!('id' in value) || value['id'] === undefined) return false;
  return true;
}

export function BillingAccountIDFromJSON(json: any): BillingAccountID {
  return BillingAccountIDFromJSONTyped(json, false);
}

export function BillingAccountIDFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BillingAccountID {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
  };
}

export function BillingAccountIDToJSON(json: any): BillingAccountID {
  return BillingAccountIDToJSONTyped(json, false);
}

export function BillingAccountIDToJSONTyped(
  value?: BillingAccountID | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
  };
}
